<template>
<div class="chapter">
<div class="inner_page">
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/P6-1.jpg"/></p>
<p class="caption">Celebrate the seventies with the Slipover Vest.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page6.vue?6e27d0cc